import LegalPage from './LegalPage';

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-medium text-[#00163E] mb-3">{title}</h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p className="mb-3">{children}</p>;
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1.5 mb-3 ml-2">
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export default function AvisoLegalPage() {
  return (
    <LegalPage title="Aviso Legal" pageTitle="Aviso Legal | Conadvy" description="Aviso legal y condiciones de uso del sitio web conadvy.com." path="/legal">
      <p className="text-[#8A9BB1] text-xs mb-8">Última actualización: [FECHA]</p>

      <Section title="1. Identificación del titular">
        <P>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se facilitan los siguientes datos identificativos del titular del sitio web conadvy.com:</P>
        <List items={[
          'Denominación social: [RAZÓN SOCIAL, S.L.]',
          'NIF/CIF: [NIF/CIF]',
          'Domicilio social: [DOMICILIO SOCIAL COMPLETO]',
          'Datos registrales: [Inscrita en el Registro Mercantil de ___, Tomo ___, Folio ___, Hoja ___]',
          'Correo electrónico de contacto: contacto@conadvy.com',
        ]} />
      </Section>

      <Section title="2. Objeto">
        <P>Conadvy es un servicio de intermediación profesional que conecta empresas con profesionales senior independientes ("Advisors") a través de un proceso confidencial de diagnóstico, selección y presentación de un máximo de tres perfiles.</P>
        <P>El sitio web tiene como finalidad informar sobre los servicios de Conadvy y permitir a empresas y profesionales iniciar el proceso de evaluación y diagnóstico previo a la prestación del servicio.</P>
      </Section>

      <Section title="3. Uso del sitio web">
        <P>El usuario se compromete a utilizar el sitio web de forma diligente, correcta y lícita. Queda prohibido:</P>
        <List items={[
          'Utilizar el sitio web con fines ilícitos, fraudulentos o que atenten contra los derechos e intereses de terceros.',
          'Difundir contenidos de carácter racista, xenófobo, pornográfico, de apología del terrorismo o que atenten contra los derechos humanos.',
          'Provocar daños en los sistemas físicos y lógicos de Conadvy, de sus proveedores o de terceros.',
          'Introducir o difundir virus informáticos o cualesquiera otros sistemas susceptibles de causar daños.',
          'Intentar acceder, utilizar o manipular los datos de Conadvy, de terceros proveedores o de otros usuarios.',
        ]} />
      </Section>

      <Section title="4. Propiedad intelectual e industrial">
        <P>Todos los contenidos del sitio web (textos, diseño gráfico, código fuente, logotipos, marcas, imágenes, estructura de navegación y la metodología propia de Conadvy) están protegidos por las normas de propiedad intelectual e industrial y son titularidad de Conadvy o de sus legítimos titulares.</P>
        <P>Queda prohibida la reproducción, distribución, comunicación pública o transformación de cualquier contenido del sitio web sin la autorización previa y por escrito de Conadvy.</P>
      </Section>

      <Section title="5. Contenido informativo">
        <P>La información proporcionada en el sitio web tiene carácter meramente informativo y no constituye, en ningún caso, asesoramiento profesional de ningún tipo (legal, financiero, estratégico u otro). Conadvy no será responsable de las decisiones tomadas en base a dicha información.</P>
      </Section>

      <Section title="6. Responsabilidad">
        <P>Conadvy no se responsabiliza de los eventuales errores tipográficos, formales o numéricos que pueda contener el sitio web, ni de la exactitud de la información contenida en el mismo. Asimismo, Conadvy no garantiza la disponibilidad ni la continuidad del funcionamiento del sitio web.</P>
        <P>En cuanto a enlaces a sitios de terceros, Conadvy no asume responsabilidad alguna sobre el contenido, funcionamiento o políticas de privacidad de sitios web ajenos.</P>
      </Section>

      <Section title="7. Protección de datos">
        <P>El tratamiento de los datos personales facilitados a través de este sitio web se rige por nuestra <a href="/privacidad" className="text-[#C58C40] hover:underline">Política de Privacidad</a>.</P>
      </Section>

      <Section title="8. Legislación aplicable y jurisdicción">
        <P>Las relaciones establecidas entre Conadvy y el usuario se regirán por la legislación española vigente. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de [CIUDAD DEL DOMICILIO SOCIAL], con renuncia expresa a cualquier otro fuero que pudiera corresponderles.</P>
      </Section>
    </LegalPage>
  );
}
